import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ServicesIndex from "@/pages/ServicesIndex";
import ServicePage from "@/pages/ServicePage";
import CitiesIndex from "@/pages/CitiesIndex";
import CityPage from "@/pages/CityPage";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import Article from "@/pages/Article";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

function PublicApp() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<ServicesIndex />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/villes" element={<CitiesIndex />} />
        <Route path="/serrurier/:slug" element={<CityPage />} />
        <Route path="/conseils" element={<Blog />} />
        <Route path="/conseils/:slug" element={<Article />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/*" element={<PublicApp />} />
      </Routes>
      <Toaster position="top-center" richColors theme="light" />
    </BrowserRouter>
  );
}

export default App;
